'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  calendars: {
    calendarFormOptionsBox: {
      allowEventDelete: 'Permettre la suppression d’événements',
      audiences: 'Publics',
      categories: 'Catégories',
      hide: 'Cacher',
      media: 'Images',
      multipleMedia: 'Plusieurs images',
      show: 'Afficher',
      singleMedia: 'Une seule image',
      taxonomies: 'Taxonomies',
      title: 'Formulaire et classification',
      groups: 'Groupes',
      tags: 'Mots-clés',
      organization: 'Organisation',
      contactInformation: 'Information de contact',
      widget: 'Création de widget',
      multipleVenues: 'Lieux multiples',
      types: 'Types',
      regions: 'Régions'
    },
    calendarOptions: 'Réglages du calendrier',
    createWidget: 'Créer un widget',
    form: {
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 ce calendrier\xA0?'
    },
    widget: {
      number: 'Nombre maximum d’événements',
      width: 'Largeur',
      height: 'Hauteur',
      filters: 'Filtres',
      copy: 'Copier le code',
      copied: 'Copié!',
      hideRecurrences: 'Masquer les récurrences'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/calendars.js
// module id = 2292
// module chunks = 0